"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["for"];
const _hoisted_2 = ["id", "aria-expanded", "aria-activedescendant", "maxlength", "value", "placeholder"];
const _hoisted_3 = {
    id: "inputDescription",
    class: "sr-only"
};
const _hoisted_4 = ["aria-label", "aria-disabled"];
const _hoisted_5 = ["aria-label"];
const _hoisted_6 = ["aria-label"];
const _hoisted_7 = ["aria-label"];
const _hoisted_8 = {
    role: "status",
    class: "sr-only"
};
const vue_3 = require("vue");
const vue_i18n_1 = require("vue-i18n");
const use_search_1 = __importStar(require("@/SearchApp/composables/use-search"));
const use_department_1 = __importDefault(require("@/SearchApp/composables/use-department"));
const ocm_object_1 = require("@ocm/services/ocm-object");
const SvgIcon_vue_1 = __importDefault(require("@SharedVueComponents/SvgIcon/SvgIcon.vue"));
const core_1 = require("@vueuse/core");
const TypeAhead_vue_1 = __importDefault(require("./TypeAhead.vue"));
const injectionKeys_1 = require("@/SearchApp/constants/injectionKeys");
const services_skipLinks_1 = require("@ocm/services/services.skipLinks");
const dataLayer_1 = require("@/SearchApp/services/dataLayer");
const TYPE_AHEAD_LISTBOX_ID = "typeAheadListbox";
exports.default = (0, vue_1.defineComponent)({
    __name: 'SearchForm',
    props: {
        inDrawer: { type: Boolean }
    },
    setup(__props) {
        const { t } = (0, vue_i18n_1.useI18n)();
        const props = __props;
        const INPUT_ID = services_skipLinks_1.skipLinks.search.input.slice(1); // #header-search
        const { departmentCapitalized } = (0, use_department_1.default)();
        const { isLoading, userInput, userInputMaxlength, setInputElementRef, openSearch, triggerSearch, deleteSearch, onKeyDown, onInput, isSearchVisible, nrOfDisplayedTypeAheadItems, } = (0, use_search_1.default)();
        const typeAheadContainerEl = (0, vue_3.useTemplateRef)("typeAheadContainerEl");
        (0, vue_3.provide)(injectionKeys_1.typeAheadContainerKey, typeAheadContainerEl);
        const inputEl = (0, vue_3.useTemplateRef)("inputEl");
        const isFocusOnInput = (0, vue_3.ref)(false);
        (0, vue_3.onMounted)(() => {
            setInputElementRef(inputEl.value);
        });
        const isInputEmpty = (0, vue_3.computed)(() => userInput.value === "");
        const showSearchBox = (0, vue_3.computed)(() => props.inDrawer ||
            (isSearchVisible.value && isFocusOnInput.value && (isLoading.value || !!nrOfDisplayedTypeAheadItems.value)));
        function handleInputFocus() {
            isFocusOnInput.value = true;
            openSearch();
        }
        function handleInputBlur() {
            // delay to allow click event on typeAheadItem to be processed first
            window.setTimeout(() => {
                isFocusOnInput.value = false;
                use_search_1.focusedTypeAheadIndex.value = -1;
            }, 200);
        }
        function handleInputClick() {
            if (!props.inDrawer)
                (0, dataLayer_1.tr_searchClick)("Field");
        }
        const _debounceSearch = (0, core_1.useDebounceFn)(triggerSearch, 600);
        const speech = (0, core_1.useSpeechRecognition)({ lang: ocm_object_1.language, interimResults: false });
        const { isListening, isSupported: isSpeechSupported } = speech;
        const triggerSpeech = () => speech.toggle(!isListening.value);
        (0, vue_3.watch)(speech.result, (result) => {
            speech.stop();
            userInput.value = result;
            _debounceSearch("voice");
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("form", {
                role: "search",
                onSubmit: _cache[5] || (_cache[5] = (0, vue_2.withModifiers)(($event) => ((0, vue_2.unref)(triggerSearch)('keyboard')), ["prevent"]))
            }, [
                (0, vue_2.createElementVNode)("div", {
                    class: (0, vue_2.normalizeClass)(["tw relative mx-4 mb-7 mt-8 h-10 focus-within:text-black-primary px1408:m-0 px1408:w-80", { 'text-gray-80': isInputEmpty.value }]),
                    onKeydown: _cache[4] || (_cache[4] =
                        //@ts-ignore
                        (...args) => ((0, vue_2.unref)(onKeyDown) && (0, vue_2.unref)(onKeyDown)(...args)))
                }, [
                    (0, vue_2.createElementVNode)("label", {
                        for: (0, vue_2.unref)(INPUT_ID),
                        class: "sr-only"
                    }, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("siteWide.searchApp.search.label")), 9, _hoisted_1),
                    (0, vue_2.createElementVNode)("input", {
                        id: (0, vue_2.unref)(INPUT_ID),
                        ref_key: "inputEl",
                        ref: inputEl,
                        role: "combobox",
                        "aria-controls": TYPE_AHEAD_LISTBOX_ID,
                        "aria-expanded": showSearchBox.value,
                        "aria-activedescendant": (0, vue_2.unref)(use_search_1.focusedTypeAheadId),
                        "aria-describedby": "inputDescription",
                        type: "text",
                        class: "h-10 w-full scroll-mt-2 rounded-full bg-gray-20 px-11 text-black-primary outline outline-transparent placeholder:text-gray-80 hover:bg-gray-40 focus:bg-gray-40 focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-current",
                        maxlength: (0, vue_2.unref)(userInputMaxlength),
                        value: (0, vue_2.unref)(userInput),
                        placeholder: (0, vue_2.unref)(isListening)
                            ? (0, vue_2.unref)(t)('siteWide.searchApp.search.placeholderListening')
                            : (0, vue_2.unref)(t)('siteWide.searchApp.search.placeholder', { department: (0, vue_2.unref)(departmentCapitalized) }),
                        autocomplete: "off",
                        "aria-autocomplete": "list",
                        onInput: _cache[0] || (_cache[0] = ($event) => ((0, vue_2.unref)(onInput)($event.target))),
                        onKeyup: _cache[1] || (_cache[1] = (0, vue_2.withKeys)(($event) => ((0, vue_2.unref)(triggerSearch)('keyboard')), ["enter"])),
                        onClick: handleInputClick,
                        onFocus: handleInputFocus,
                        onBlur: handleInputBlur
                    }, null, 40, _hoisted_2),
                    (0, vue_2.createElementVNode)("span", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("siteWide.searchApp.search.resultsUpdating")), 1),
                    (0, vue_2.createElementVNode)("button", {
                        type: "submit",
                        class: "absolute left-3.5 top-1/2 grid size-6 -translate-y-1/2 place-content-center",
                        "aria-label": (0, vue_2.unref)(t)('siteWide.searchApp.search.submit'),
                        "aria-disabled": isInputEmpty.value,
                        onClick: _cache[2] || (_cache[2] = ($event) => ((0, vue_2.unref)(triggerSearch)('click')))
                    }, [
                        (0, vue_2.createVNode)(SvgIcon_vue_1.default, {
                            "icon-name": "magnifying-glass",
                            class: "size-5"
                        })
                    ], 8, _hoisted_4),
                    ((0, vue_2.unref)(isSpeechSupported) && isInputEmpty.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                            key: 0,
                            type: "button",
                            class: (0, vue_2.normalizeClass)(["absolute right-3.5 top-1/2 grid size-6 -translate-y-1/2 place-content-center rounded-xl", (0, vue_2.unref)(isListening) ? 'srh__bg-pulse text-white' : ' supportsHover:hover:text-black-primary']),
                            "aria-label": (0, vue_2.unref)(isListening) ? (0, vue_2.unref)(t)('siteWide.searchApp.search.speechStop') : (0, vue_2.unref)(t)('siteWide.searchApp.search.speechStart'),
                            onClick: triggerSpeech
                        }, [
                            (0, vue_2.createVNode)(SvgIcon_vue_1.default, {
                                "icon-name": "mic",
                                class: "size-5"
                            })
                        ], 10, _hoisted_5))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                            key: 1,
                            type: "button",
                            class: (0, vue_2.normalizeClass)(["absolute right-3.5 top-1/2 size-6 -translate-y-1/2 place-content-center rounded-xl", isInputEmpty.value ? 'hidden' : 'grid']),
                            "aria-label": (0, vue_2.unref)(t)('siteWide.searchApp.search.clearInput'),
                            onClick: _cache[3] || (_cache[3] =
                                //@ts-ignore
                                (...args) => ((0, vue_2.unref)(deleteSearch) && (0, vue_2.unref)(deleteSearch)(...args)))
                        }, [
                            (0, vue_2.createVNode)(SvgIcon_vue_1.default, {
                                "icon-name": "close-new",
                                class: "size-5"
                            })
                        ], 10, _hoisted_6))
                ], 34),
                (0, vue_2.createElementVNode)("div", {
                    id: TYPE_AHEAD_LISTBOX_ID,
                    ref_key: "typeAheadContainerEl",
                    ref: typeAheadContainerEl,
                    role: "listbox",
                    "aria-label": (0, vue_2.unref)(t)('siteWide.searchApp.search.suggestions'),
                    class: (0, vue_2.normalizeClass)(["o-scrollbar max-h-[calc(100vh-200px)] overscroll-contain", [
                            _ctx.inDrawer
                                ? 'px-4 pb-4'
                                : 'absolute right-0 top-full z-[100] max-h-[calc(100vh-200px)] w-[35.7142857rem] border-t-2 border-t-gray-40 bg-white p-4 text-sm shadow-4',
                            { hidden: !showSearchBox.value },
                        ]]),
                    style: { "clip-path": "inset(0 -10px -10px -10px)" }
                }, [
                    ((0, vue_2.unref)(isLoading))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(t)("siteWide.searchApp.loading")), 1)
                        ], 64))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(TypeAhead_vue_1.default, { key: 1 }))
                ], 10, _hoisted_7),
                (0, vue_2.createElementVNode)("div", _hoisted_8, (0, vue_2.toDisplayString)((0, vue_2.unref)(nrOfDisplayedTypeAheadItems) === 0 ? (0, vue_2.unref)(t)("siteWide.searchApp.search.noResults") : ""), 1)
            ], 32));
        };
    }
});
